document.addEventListener( 'DOMContentLoaded', () => {
	const menus = document.querySelectorAll( '.js-mobile-menu' );

	if ( ! menus.length ) {
		return;
	}

	menus.forEach( ( menu ) => {
		const toggle = menu.querySelector( '.js-mobile-menu-toggle' );
		const links = menu.querySelectorAll( '.mobile-menu__list a' );

		if ( ! toggle ) {
			return;
		}

		toggle.addEventListener( 'click', () => {
			const isOpen = menu.classList.toggle( 'is-open' );

			toggle.setAttribute( 'aria-expanded', String( isOpen ) );
			toggle.setAttribute(
				'aria-label',
				isOpen ? 'Zamknij menu' : 'Otwórz menu'
			);
		} );

		links.forEach( ( link ) => {
			link.addEventListener( 'click', () => {
				menu.classList.remove( 'is-open' );
				toggle.setAttribute( 'aria-expanded', 'false' );
				toggle.setAttribute( 'aria-label', 'Otwórz menu' );
			} );
		} );
	} );
} );
